export default __webpack_public_path__ + "static/media/GoogleFonts.b2e0d4b6.png";